export default __webpack_public_path__ + "static/media/cherche-lerreur.28b21478.svg";